import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableMiniMuroModalPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "minimuropopup" */
        './MiniMuroModal'
      )
  )
);

interface Props {
  requestClose: () => void;
}

const LazyMiniMuroModalPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyMiniMuroModalPopup">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableMiniMuroModalPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyMiniMuroModalPopup.displayName = 'LazyMiniMuroModalPopup';

export default LazyMiniMuroModalPopup;
